module.exports = __webpack_public_path__ + "img/boss1.41403839.jpg";